import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cascade_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const getToolkits = () => api.get("/toolkits").then((r) => r.data);
export const getToolkit = (id) => api.get(`/toolkits/${id}`).then((r) => r.data);
export const getBlog = () => api.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const startCheckout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

// Auth
export const login = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);

// Admin
export const getStats = () => api.get("/admin/stats").then((r) => r.data);
export const getBookings = () => api.get("/bookings").then((r) => r.data);
export const getPurchases = () => api.get("/admin/purchases").then((r) => r.data);
export const createPost = (payload) => api.post("/admin/blog", payload).then((r) => r.data);
export const updatePost = (slug, payload) => api.put(`/admin/blog/${slug}`, payload).then((r) => r.data);
export const deletePost = (slug) => api.delete(`/admin/blog/${slug}`).then((r) => r.data);
export const updateToolkit = (id, payload) => api.put(`/admin/toolkits/${id}`, payload).then((r) => r.data);

export const previewToolkitPdf = async (lookupKey, filename) => {
  const resp = await api.get(`/admin/toolkits/${lookupKey}/preview`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([resp.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || `${lookupKey}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
